export const PRR_MODE = import.meta.env.VITE_PRR_MODE === "true";

export function isPrrMode(): boolean {
  return PRR_MODE;
}

